import { Observable } from 'rxjs';
import { HttpClient } from './http-client';
import { IBudget } from '../pages/finance/budget/blueprint';

export class BudgetService extends HttpClient {
  index(farm_id: string, season_id: string): Observable<Array<IBudget>> {
    return this.get<Array<IBudget>>(
      `/api/farms/${farm_id}/budget/${season_id}`
    );
  }

  store(
    farm_id: string,
    season_id: string,
    budgets: any
  ): Observable<Array<IBudget>> {
    return this.post<Array<IBudget>>(
      `/api/farms/${farm_id}/budget/${season_id}`,
      budgets
    );
  }

  update(
    farm_id: string,
    season_id: string,
    budgets: any
  ): Observable<Array<IBudget>> {
    return this.put<Array<IBudget>>(
      `/api/farms/${farm_id}/budget/${season_id}`,
      budgets
    );
  }

  destroy(
    farm_id: string,
    season_id: string,
    budgets: any
  ): Observable<Array<IBudget>> {
    return this.post<Array<IBudget>>(
      `/api/farms/${farm_id}/budget/${season_id}/destroy`,
      budgets
    );
  }
}
